"use client";
import React, { useState } from "react";
import {
  ProfileDesc,
  ProfileDetails,
  UserCard,
  UserDesination,
} from "./molecules";
import Image from "next/image";
import { useDictionary } from "../context/dictionaryProvider";

const ProfileCard = ({ image, name, title, description, brand }) => {
  const dict = useDictionary();
  const [isExpanded, setIsExpanded] = useState(false);
  const handleReadMore = () => {
    setIsExpanded(!isExpanded);
  };
  const QuoteIcon = () => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute left-[30px] top-5 z-10"
      >
        <path
          d="M62.6123 44.6616C62.6123 46.2379 62.254 47.6352 61.5375 48.8533C60.8926 49.9998 60.0328 50.9671 58.958 51.7553C57.8832 52.5435 56.7009 53.1526 55.4111 53.5825C54.193 53.9407 53.0465 54.1199 51.9717 54.1199C50.3237 54.1199 48.6398 53.7616 46.9201 53.0451C45.2721 52.2569 43.7673 51.1462 42.4059 49.7132C41.0445 48.2801 39.9338 46.5604 39.074 44.5541C38.2141 42.5478 37.7842 40.3265 37.7842 37.8903C37.7842 33.6627 38.5724 30.0442 40.1488 27.0347C41.7968 24.0252 43.7315 21.5173 45.9528 19.511C48.2457 17.4331 50.5745 15.8208 52.939 14.6744C55.3753 13.4563 57.3816 12.5964 58.958 12.0948V15.5342C57.5249 16.3941 55.9843 17.3256 54.3363 18.3287C52.7599 19.3319 51.291 20.5142 49.9296 21.8756C48.6398 23.237 47.565 24.7776 46.7051 26.4973C45.8453 28.217 45.4154 30.1516 45.4154 32.3013C45.4154 33.3761 45.5229 34.2359 45.7378 34.8808C45.9528 35.5257 46.2036 36.0273 46.4902 36.3855C46.8484 36.7438 47.1709 36.9946 47.4575 37.1379C47.8158 37.2812 48.1024 37.3529 48.3174 37.3529C49.1055 37.3529 50.0729 37.1379 51.2193 36.708C52.3658 36.2064 53.4406 35.9556 54.4438 35.9556C55.3753 35.9556 56.3068 36.1706 57.2383 36.6005C58.2414 36.9588 59.1371 37.532 59.9253 38.3202C60.7135 39.0367 61.3584 39.9324 61.86 41.0072C62.3615 42.082 62.6123 43.3001 62.6123 44.6616ZM29.0917 44.4466C29.0917 46.023 28.7334 47.4202 28.0169 48.6384C27.372 49.8565 26.5122 50.8596 25.4374 51.6478C24.3625 52.3644 23.1803 52.9376 21.8905 53.3675C20.6724 53.7258 19.4901 53.9049 18.3436 53.9049C16.6956 53.9049 15.0475 53.5466 13.3995 52.8301C11.7515 52.0419 10.2467 50.9671 8.88529 49.6057C7.52387 48.1726 6.41323 46.4529 5.55338 44.4466C4.76519 42.4403 4.37109 40.219 4.37109 37.7828C4.37109 33.5552 5.15929 29.9367 6.73567 26.9272C8.38372 23.8461 10.3184 21.3024 12.5396 19.2961C14.8326 17.2181 17.1613 15.6059 19.5259 14.4594C21.8905 13.2413 23.861 12.3815 25.4374 11.8799V15.4268C24.0043 16.2866 22.4637 17.2181 20.8157 18.2213C19.2393 19.2244 17.7704 20.4067 16.409 21.7681C15.1192 23.1296 14.0085 24.6701 13.077 26.3898C12.2172 28.0378 11.7873 29.9725 11.7873 32.1938C11.7873 34.2001 12.1814 35.5257 12.9696 36.1706C13.8294 36.8155 14.4743 37.1379 14.9042 37.1379C15.6208 37.1379 16.5523 36.9229 17.6987 36.493C18.8452 36.0631 19.92 35.8481 20.9232 35.8481C21.8547 35.8481 22.7862 36.0631 23.7177 36.493C24.7208 36.8513 25.6165 37.4245 26.4047 38.2127C27.1929 38.9292 27.8378 39.8249 28.3393 40.8997C28.8409 41.9029 29.0917 43.0852 29.0917 44.4466Z"
          fill="#FFDA73"
        />
      </svg>
    );
  };
  return (
    <>
      <UserCard className="lg:mb-10 xl:mb-28">
        <QuoteIcon />
        <div
          className="h-[480px] 2xl:h-[610px]"
          style={{
            position: "relative",
            width: "100%",
            borderRadius: "16px",
            overflow: "hidden",
          }}
        >
          <Image
            src={image}
            alt=""
            fill
            objectFit="cover"
            width=""
            height=""
            loading="lazy"
          ></Image>
        </div>
        <ProfileDetails className="card-content">
          <h2 className="text-white font-semibold text-base">{name}</h2>
          <UserDesination>{title}</UserDesination>
          <ProfileDesc
            className={`${
              isExpanded ? "max-h-32 overflow-auto" : "max-h-10 overflow-hidden"
            } transform transition-all duration-500`}
          >
            {description}
          </ProfileDesc>
          <button
            href="#"
            className="read-more underline underline-offset-4"
            onClick={handleReadMore}
          >
            {isExpanded ? dict?.readLess : dict?.readMore}
          </button>
        </ProfileDetails>
      </UserCard>
    </>
  );
};

export default ProfileCard;
